import { DialogData } from './../../../../pages/material/popups-and-modals/dialog/dialog.component';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PurchaseOrdersService } from 'app/core/o2c/processing';
import { PurchaseOrderModel } from 'app/core/o2c/processing/models/purchase-order-model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';
import { finalize } from 'rxjs/operators';

@Component({
  standalone: false,
    selector: 'kt-invoice-po-dialog',
    templateUrl: './invoice-po-comparinson-dialog.component.html',
    styleUrls: ['./invoice-po-comparinson-dialog.component.scss']
})
/**
 * Class that define the behavior of the pdf-viewer component
 * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
 * @since 2019-12-4
 */
export class InvoicePODialogComponent implements OnInit {
	@ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;

    /**
     * Receives the coming data (base64 string) to set the pdf
     */
    @Input() public podata: PurchaseOrderModel;
	/**
     * Switch to compare view
     */
	 @Input() compareView: boolean;

	 @Input() invoicebase64: string;

   @Input() message: string;
   @Input() buttonMessage: string;

   @Input() public showLoading: boolean = false;

   @Input() public showButtons: boolean = true;

   @Output() accept = new EventEmitter<any>(true);
   /**
     * Stores the status of the loader
     */
    public loader: boolean = false;

    /**
     * Receive the invoice number
     */
    @Input() public invoiceNumber: string;
	  @Input() acept: boolean;

    /**
     * Creation date for 3PL
     */
    @Input() public fileName: string;

    /**
     * Invoice search data
     */
    @Input() public invoiceSearchData: any;

    /**
     * Store the path to show the pdf
     */
    public pathNormalView: string;

    /**
     * Store the path to show the pdf
     */
    public pathCompareView1: string;

    /**
     * Store the path to show the pdf
     */
    public pathCompareView2: string;

    /**
     * Set the name for the pdf file to download
     */
    public name: string;



    /**
     * Handle loaders
     */
    loaders: { dataSource: boolean, pdfSource1: boolean, pdfSource2: boolean };

    /**
     * Defines the history length collection for  the actual PO
     */
    historyLength: number;

    /**
     * Value of the PO 1 Select
     */
    selected1Value: number;

    /**
     * Value of the PO 2 Select
     */
    selected2Value: number;

    /**
     * History of changes for the actual PO
     */
    history: PurchaseOrderModel[];

    /**
     * Last change date and time
     */
    lastChangeString: string;


    /**
     * po 2 text
     */
    po2OrderTypeString: string;

    /**
     * po 2 text
     */
    po2DateString: string;
	renderText = true;
	originalSize = false;
	fitToPage = false;
	showAll = true;
	autoresize = false;
	showBorders = true;
	renderTextModes = [0, 1, 2];
	renderTextMode = 1;
	rotation = 0;
	zoom = 1;
	zoomScale = 'page-width';
	zoomScales = ['page-width', 'page-fit', 'page-height'];
	pdfQuery = '';
	totalPages: number;

	renderText1 = true;
	originalSize1 = false;
	fitToPage1 = false;
	showAll1 = true;
	autoresize1 = false;
	showBorders1 = true;
	renderTextModes1 = [0, 1, 2];
	renderTextMode1 = 1;
	rotation1 = 0;
	zoom1 = 1;
	zoomScale1 = 'page-width';
	zoomScales1 = ['page-width', 'page-fit', 'page-height'];
	pdfQuery1 = '';
	totalPages1: number;

	renderText2 = true;
	originalSize2 = false;
	fitToPage2 = false;
	showAll2 = true;
	autoresize2 = false;
	showBorders2 = true;
	renderTextModes2 = [0, 1, 2];
	renderTextMode2 = 1;
	rotation2 = 0;
	zoom2 = 1;
	zoomScale2 = 'page-width';
	zoomScales2 = ['page-width', 'page-fit', 'page-height'];
	pdfQuery2 = '';
	totalPages2: number;
    constructor(
        public dialogRef: MatDialogRef<InvoicePODialogComponent>,
        private poService: PurchaseOrdersService,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {

        this.historyLength = 0;
        this.lastChangeString = '';
        this.po2OrderTypeString = '';
        this.po2DateString = '';
    }

    ngOnInit() {
        this.initLoaders();
        if (this.podata) {
            this.viewPONumber(this.podata);
        }
    }

    /**
     * Method to start/reset the loaders for buttons
     * like sent/print, hold and release
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-9
     */
    private initLoaders() {
        this.loaders = {
            dataSource: false,
            pdfSource1: false,
            pdfSource2: false
        };
    }

    /**
     * Closes the actual modal
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2019-12-4
     */
    public close() {
      this.dialogRef.close();
	  this.accept.emit(false);
    }

    /**
       * Closes the actual modal
       * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
       * @since 2019-12-4
       */
    public aceptModal() {
      if(this.showLoading) {
        this.loader = this.showLoading;
        this.accept.emit(this.data.result);
      } else {
    	//this.dialogRef.close(this.data.result);
        this.accept.emit(false);
      }
    }

    /**
     * Switcher for view type
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-17
     */
    switchCompareView(): void {
        this.compareView = !this.compareView;
    }

    /**
     * Open the modal to view and compare the po pdf changed and original
     * @param id Purchase order id selected from table
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-9
     */
    viewPONumber(item: PurchaseOrderModel) {

        this.getPOHistory(item.customerNumber, item.poNumber);
    }

    /**
     * Generate a pdf source for the specified id
     * @param id id for the PO
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-17
     */
    generatePDFPO(id: string) {
        this.poService.generatePDFPO(id)
            .pipe(
                finalize(() => {
                    this.loaders.dataSource = true;
                })
            )
            .subscribe(
                data => {
                    this.name = this.fileName;
                    this.pathNormalView = this.base64ToURI(String(data));
                },
            );
    }

    /**
     * Get the PO history
     * @param customerNumber customer number
     * @param poNumber PO number
     * @param method optional, flag to know if we don't have a purchase order data, ex: when coming from invoice search
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-17
     */
    getPOHistory(customerNumber: string, poNumber: string, method?: boolean) {
        this.poService.getPOHistory(customerNumber, poNumber)
            .subscribe(
                data => {
                    this.sortByDate(data);
                    this.historyLength = data.length;
                    this.history = this.podata ? data.filter(x => x.id !== this.podata.id) : data;
                    // if the list have more than one result must load
                    // the first and last PDF
                   if(this.compareView)
				   {
  						// set the initial values for the selects


                        // set the initial pdf
						this.pathCompareView1 = this.base64ToURI(this.invoicebase64);
						this.loaders.pdfSource1 = true;

                        this.getFirstAndLastPO(data[this.historyLength - 1]);
				   }
				   else
				   {
					this.name = this.fileName;
                    this.pathNormalView = this.base64ToURI(this.invoicebase64);
					this.loaders.dataSource = true;
				   }


                },
            );
    }

   

    /**
     * handle undefined value for date
     * @param date date
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-08-05
     */
    private getTime(date?: Date) {
        return date != null ? date.getTime() : 0;
    }

    /**
     * Sort purchase order list by date
     * @param data array of purchase orders
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-08-05
     */
    public sortByDate(data: PurchaseOrderModel[]): void {
        data.sort((a: PurchaseOrderModel, b: PurchaseOrderModel) => {
            return this.getTime(new Date(a.systemDate)) - this.getTime(new Date(b.systemDate));
        });
    }

    /**
     * Initial PDF to show in the compare view
     * @param item1 first item of the history
     * @param item2 last item of the history
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-17
     */
    getFirstAndLastPO( item2: PurchaseOrderModel) {

        this.poService.generatePDFPO(String(item2.id))
            .pipe(
                finalize(() => {
                    this.loaders.pdfSource2 = true;
                })
            )
            .subscribe(
                data2 => {
                    this.pathCompareView2 = this.base64ToURI(String(data2));
                },
            );
    }

    /**
     * Obtain the URI for a file with its base64 code
     * @param base64 base64 hash
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-17
     */
    base64ToURI(base64: string): string {
        if (this.invoiceNumber) {
            // Name for the file
            this.name = 'IN' + this.invoiceNumber + '.pdf';
        }
        // decoding the data via atob()
        const byteArray = new Uint8Array(atob(base64).split('').map(char => char.charCodeAt(0)));
        // Decoded array into blob
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        // Here is your URL you can use
        return window.URL.createObjectURL(blob);
    }

    /**
     * Refresh the view in the pdf viewer selected with the value selected
     * @param event gets the id of the PO
     * @param identifier word to know if it's the first or second viewer in the compare window
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-17
     */
    updatePDF(event: number, identifier: string) {
        if (identifier === 'first') {
            this.loaders.pdfSource1 = false;
        } else if (identifier === 'second') {
            this.loaders.pdfSource2 = false;
        }
        this.poService.generatePDFPO(String(event))
            .pipe(
                finalize(() => {
                    if (identifier === 'first') {
                        this.loaders.pdfSource1 = true;
                    } else if (identifier === 'second') {
                        this.loaders.pdfSource2 = true;
                    }
                })
            )
            .subscribe(
                data => {
                    if (identifier === 'first') {
                        this.pathCompareView1 = this.base64ToURI(String(data));
                    } else if (identifier === 'second') {
                        const selecetdPO = this.history.filter(x => x.id === event);
                        this.po2OrderTypeString = selecetdPO[0].orderType;
                        this.po2DateString = selecetdPO[0].systemDate;
                        this.pathCompareView2 = this.base64ToURI(String(data));
                    }
                },
            );
    }


	zoomIn() {
		this.zoom += 0.05;
	  }

	  zoomOut() {
		if (this.zoom > 0.05)
		  this.zoom -= 0.05;
	  }

	  rotateDoc() {
		this.rotation += 90;
	  }
	  printPDF(){
		  window.open(this.pathNormalView).print();
	  }
	  searchQueryChanged(newQuery: string) {
		  if (newQuery !== this.pdfQuery) {
			this.pdfQuery = newQuery;
			(this.pdfComponent.pdfFindController as any).executeCommand('find', {
			  query: this.pdfQuery,
			  highlightAll: true
			});
		  } else {
			(this.pdfComponent.pdfFindController as any).executeCommand('findagain', {
			  query: this.pdfQuery,
			  highlightAll: true
			});
		  }
		}
		zoomIn2() {
			this.zoom2 += 0.05;
		  }

		  zoomOut2() {
			if (this.zoom2 > 0.05)
			  this.zoom2 -= 0.05;
		  }

		  rotateDoc2() {
			this.rotation2 += 90;
		  }
		  printPDF2(){
			  window.open(this.pathCompareView1).print();
		  }
		  searchQueryChanged2(newQuery: string) {
			  if (newQuery !== this.pdfQuery2) {
				this.pdfQuery2 = newQuery;
				(this.pdfComponent.pdfFindController as any).executeCommand('find', {
				  query: this.pdfQuery2,
				  highlightAll: true
				});
			  } else {
				(this.pdfComponent.pdfFindController as any).executeCommand('findagain', {
				  query: this.pdfQuery2,
				  highlightAll: true
				});
			  }
			}
			zoomIn1() {
				this.zoom1 += 0.05;
			  }

			  zoomOut1() {
				if (this.zoom1 > 0.05)
				  this.zoom1 -= 0.05;
			  }

			  rotateDoc1() {
				this.rotation1 += 90;
			  }
			  printPDF1(){
				  window.open(this.pathCompareView1).print();
			  }
			  searchQueryChanged1(newQuery: string) {
				  if (newQuery !== this.pdfQuery1) {
					this.pdfQuery1 = newQuery;
					(this.pdfComponent.pdfFindController as any).executeCommand('find', {
					  query: this.pdfQuery1,
					  highlightAll: true
					});
				  } else {
					(this.pdfComponent.pdfFindController as any).executeCommand('findagain', {
					  query: this.pdfQuery1,
					  highlightAll: true
					});
				  }
				}
				callBackFn(event) {
					console.log('callBackFn', event);
					// Setting total number of pages
					this.totalPages = event._pdfInfo.numPages
				  }
			callBackFn1(event) {
				console.log('callBackFn', event);
				// Setting total number of pages
				this.totalPages1 = event._pdfInfo.numPages
			  }
			  callBackFn2(event) {
				console.log('callBackFn', event);
				// Setting total number of pages
				this.totalPages2 = event._pdfInfo.numPages
			  }
}
